import { Dispatch, MutableRefObject, SetStateAction, useEffect, useMemo, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { RadioGroup } from '@headlessui/react';
import { Product } from '@Types/product/Product';
import { LineItem } from '@Types/wishlist/LineItem';
import Price from 'components/commercetools-ui/price';
import { useFormat } from 'helpers/hooks/useFormat';
import { useProductStore } from 'helpers/stores/productStore';
import { useCart, useWishlist } from 'frontastic';
import Image from 'frontastic/lib/image';
import { ProductItemVariant } from '../product-list';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { mobile } from 'helpers/utils/screensizes';
import { createPortal } from 'react-dom';
import { CustomImage } from 'lib/customImage';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

type Size = [number, string];

const ImgBox = ({ detailsText, detailsLink, images, recent, sale }) => {
  const [selectedImage, setSelectedImage] = useState(0);
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });

  return (
    <div className="mb-12 w-full lg:mb-0">
      <div className="-mx-4 lg:flex">
        <div className="w-full px-4 lg:-ml-3">
          <div className="relative mb-8 rounded">
            {/* <a
              href={detailsLink}
              className="text-body-color absolute bottom-4 right-5 z-10 text-sm font-medium hover:text-primary"
            >
              {detailsText}
            </a> */}
            <div className="relative rounded-[4px]">
              {/* <Image
                src={images[selectedImage]}
                alt="products-details"
                className="block w-full rounded object-contain lg:h-auto lg:w-[350px]"
              /> */}
              <CustomImage imgSrc={images[selectedImage]} width={350} height={460} />
              <div className="absolute left-2 top-2 flex flex-col items-start justify-between gap-2">
                {sale && (
                  <div className="flex items-center justify-center gap-1 rounded bg-[#E77474] px-2 py-1 text-white">
                    <p className="text-xs font-semibold">
                      {formatProductMessage({ id: 'sale', defaultMessage: 'Sale' })}
                    </p>
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_211_184)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M5.2601 1.20969C5.42417 1.0923 5.641 1.07931 5.81792 1.17627C6.36504 1.47613 7.11161 2.01577 7.66876 2.89761C8.23232 3.78957 8.58064 4.9988 8.37038 6.58826C8.36791 6.60694 8.36706 6.62081 8.367 6.63083C8.39186 6.63517 8.4391 6.63758 8.51054 6.6164C8.71512 6.55576 9.01409 6.31551 8.9819 5.74971C8.96899 5.52283 9.10352 5.3134 9.31522 5.2308C9.52692 5.1482 9.76773 5.21117 9.91189 5.38684C10.6705 6.31124 11.5449 7.85631 11.6287 9.4849C11.6712 10.3114 11.5097 11.168 11.0168 11.9625C10.5246 12.7559 9.72553 13.4494 8.55615 13.9915C8.34078 14.0913 8.08522 14.0342 7.93283 13.8522C7.78043 13.6702 7.76912 13.4086 7.90524 13.2141C8.1604 12.8496 8.49801 11.882 7.78262 10.9877C7.77356 10.9764 7.76498 10.9647 7.75689 10.9527C7.72895 10.9111 7.70497 10.8827 7.66755 10.8383C7.64267 10.8088 7.61184 10.7722 7.56996 10.7201C7.4816 10.61 7.37428 10.4625 7.29508 10.2655C7.24412 10.1387 7.20934 10.0035 7.19191 9.85713C6.91137 10.0857 6.63847 10.368 6.42307 10.6986C5.9921 11.3601 5.78034 12.2249 6.22345 13.3179C6.30382 13.5162 6.25587 13.7433 6.10224 13.8922C5.94861 14.041 5.72003 14.0818 5.52441 13.9952C4.57229 13.5738 3.33288 12.6562 2.75581 11.2397C2.16059 9.77869 2.32039 7.91545 3.94633 5.74752L3.94633 5.74752C4.52866 4.9711 5.35445 3.48153 5.0484 1.72687C5.01373 1.52812 5.09602 1.32709 5.2601 1.20969ZM8.36938 6.65336C8.36922 6.65356 8.3686 6.65219 8.36804 6.6487C8.36927 6.65142 8.36955 6.65317 8.36938 6.65336ZM6.1605 2.71032C6.09608 4.35064 5.31814 5.66846 4.78633 6.37753C3.32844 8.32138 3.30264 9.79896 3.72821 10.8436C3.99146 11.4897 4.44619 12.0175 4.93744 12.4129C4.87354 11.5264 5.13335 10.7547 5.54332 10.1254C6.126 9.23111 7.00047 8.63589 7.63632 8.3527C7.82495 8.26869 8.04531 8.30305 8.1994 8.4405C8.35349 8.57796 8.41269 8.79297 8.35069 8.98993C8.17683 9.54219 8.22822 9.77161 8.26929 9.87379C8.29316 9.93314 8.32874 9.98799 8.38866 10.0626C8.39893 10.0754 8.41339 10.0927 8.4305 10.1131C8.48172 10.1743 8.55678 10.264 8.61494 10.3474C9.15478 11.0302 9.2986 11.7402 9.25662 12.3549C9.64189 12.0533 9.92326 11.7334 10.1246 11.409C10.4869 10.8249 10.6135 10.1881 10.5801 9.53883C10.5329 8.62096 10.1655 7.69679 9.71826 6.94073C9.48965 7.28539 9.16023 7.51898 8.80895 7.62311C8.48506 7.71911 8.09695 7.71397 7.77832 7.50889C7.42502 7.28151 7.27217 6.88361 7.32945 6.45057C7.50844 5.09747 7.20954 4.13658 6.78109 3.45844C6.5948 3.16359 6.38 2.91605 6.1605 2.71032Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_211_184">
                          <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                )}
                {recent && (
                  <div className="flex items-center justify-center gap-1 rounded bg-secondary px-2 py-1 text-white">
                    <p className="text-xs font-semibold">
                      {formatProductMessage({ id: 'new', defaultMessage: 'New' })}
                    </p>
                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.1937 4.98125L7.79997 4.45625L6.26247 1.23125C6.14997 1.00625 5.84997 1.00625 5.73747 1.23125L4.19997 4.475L0.82497 4.98125C0.58122 5.01875 0.48747 5.3375 0.67497 5.50625L3.13122 8.0375L2.54997 11.5812C2.51247 11.825 2.75622 12.0312 2.98122 11.8813L6.03747 10.2125L9.07497 11.8813C9.28122 11.9938 9.54372 11.8062 9.48747 11.5812L8.90622 8.0375L11.3625 5.50625C11.5125 5.3375 11.4375 5.01875 11.1937 4.98125Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                )}
              </div>
            </div>
          </div>
          <a href={detailsLink} className="text-sm font-medium text-primary hover:text-[#33B8A1]">
            {detailsText}
          </a>
        </div>
        <div className="mb-12 mt-4 w-full px-4 md:order-first md:mb-0 lg:mt-0 lg:max-w-[136px]">
          <div className="-mx-2 flex flex-wrap items-center">
            {images.map((image, idx) => (
              <div className="w-1/4 px-2 lg:w-full" key={idx}>
                <button
                  onClick={() => {
                    setSelectedImage(idx);
                  }}
                  className={`${
                    idx === selectedImage ? 'border-primary' : 'border-stroke dark:border-dark-3'
                  } w-full overflow-hidden rounded border md:mb-5`}
                >
                  {/* <Image src={image} className="w-full rounded" /> */}
                  <CustomImage imgSrc={image} width={100} height={100} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const QuickView = ({
  id,
  variant,
  sizes,
  colors,
  inStock,
  variants,
}: {
  id: string;
  variant: ProductItemVariant;
  sizes: Size[];
  colors: string[];
  inStock: boolean;
  variants: ProductItemVariant[];
}) => {
  const [open, setOpen] = useState(false);

  const menuTrigger = useRef(null);
  const menuRef = useRef(null);

  const useClickOutside = (refs, isOpen, setIsOpen) => {
    useEffect(() => {
      const clickHandler = ({ target }) => {
        if (!refs.some((ref) => ref.current) || !isOpen || refs.some((ref) => ref.current.contains(target))) return;
        setIsOpen(false);
      };

      document.addEventListener('click', clickHandler);
      return () => document.removeEventListener('click', clickHandler);
    }, [refs, isOpen, setIsOpen]);
  };

  useClickOutside([menuRef, menuTrigger], open, setOpen);
  return (
    <div className="text-center">
      <button
        ref={menuTrigger}
        onClick={() => setOpen(!open)}
        className="rounded-md bg-transparent bg-opacity-0 py-2 px-2 text-sm font-medium text-white hover:bg-[#F6F9FF]"
        data-testid="quick-view-button"
      >
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_209_17614)">
            <path
              d="M9.81321 8.00633C8.70696 8.00633 7.82764 8.90633 7.82764 9.97508C7.82764 11.0438 8.73533 11.9438 9.81321 11.9438C10.8911 11.9438 11.7988 11.0438 11.7988 9.97508C11.7988 8.90633 10.9195 8.00633 9.81321 8.00633ZM9.81321 10.9595C9.27427 10.9595 8.82043 10.5095 8.82043 9.97508C8.82043 9.44071 9.27427 8.99071 9.81321 8.99071C10.3522 8.99071 10.806 9.44071 10.806 9.97508C10.806 10.5095 10.3522 10.9595 9.81321 10.9595Z"
              fill="black"
            />
            <path
              d="M18.4362 9.63783C16.5641 6.71284 13.3305 4.96909 9.81315 4.96909C6.29585 4.96909 3.06219 6.71284 1.19008 9.63783C1.07662 9.83471 1.07662 10.0878 1.19008 10.2847C3.06219 13.2097 6.29585 14.9535 9.81315 14.9535C13.3305 14.9535 16.5641 13.2097 18.4362 10.2847C18.5781 10.0878 18.5781 9.83471 18.4362 9.63783ZM9.81315 13.9691C6.72133 13.9691 3.85642 12.4785 2.1545 9.94721C3.85642 7.44409 6.72133 5.95346 9.81315 5.95346C12.905 5.95346 15.7699 7.44409 17.4718 9.94721C15.7699 12.4785 12.905 13.9691 9.81315 13.9691Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_209_17614">
              <rect width="18.1538" height="17.9985" fill="white" transform="translate(0.736328 0.975662)" />
            </clipPath>
          </defs>
        </svg>
      </button>
      {open && (
        <QuickViewModal
          menuRef={menuRef}
          id={id}
          variant={variant}
          sizes={sizes}
          colors={colors}
          inStock={inStock}
          variants={variants}
          open={open}
          setOpen={setOpen}
        />
      )}
    </div>
  );
};

export const QuickViewModal = ({
  id,
  variant,
  sizes,
  colors,
  inStock,
  variants,
  open,
  setOpen,
  menuRef,
}: {
  id: string;
  menuRef: MutableRefObject<HTMLDivElement>;
  variant: ProductItemVariant;
  sizes: Size[];
  colors: string[];
  inStock: boolean;
  variants: ProductItemVariant[];
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const checkIcon = (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.9375 4.1875C18.6562 3.90625 18.2187 3.90625 17.9375 4.1875L7.3125 14.5L2.0625 9.34375C1.78125 9.0625 1.34375 9.09375 1.0625 9.34375C0.781247 9.625 0.812497 10.0625 1.0625 10.3437L6.59375 15.7187C6.78125 15.9062 7.03125 16 7.3125 16C7.59375 16 7.8125 15.9062 8.03125 15.7187L18.9375 5.125C19.2187 4.90625 19.2187 4.46875 18.9375 4.1875Z"
        fill="white"
      />
    </svg>
  );

  const router = useRouter();
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });
  const [isSizeProduct, setIsSizeProduct] = useState<boolean>(true);
  const { removeLineItem, addToWishlist, data } = useWishlist();
  const { addItem } = useCart();
  const [quantity, setQuantity] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [added, setAdded] = useState<boolean>(false);
  const [productsSelected, setProductsSelected] = useState<Record<string, Product>>({});
  const [chosenSize, setChosenSize] = useState<string | null>(null);
  const [selectedColor, setSelectedColor] = useState<string>(variant?.attributes?.color);
  const [selectedSize, setSelectedSize] = useState<string>(variant?.attributes?.size);
  const [selectedVariant, setSelectedVariant] = useState<ProductItemVariant | null>(null);
  const [relevantImages, setRelevantImages] = useState<string[]>(
    variants.find((v) => v?.attributes?.color === selectedColor)?.images,
  );
  const { size: savedSize, updateSize: updateSavedSize } = useProductStore();
  const [isMobileSize] = useMediaQuery(mobile);
  const modalRef = useRef(null);

  const getSelectedProducts = (): string => {
    if (Object.keys(productsSelected).length === 0) return undefined;

    const selected = Object.keys(productsSelected).map((category) => {
      const product = productsSelected[category];
      return `${category}:${product.productId}`;
    });

    return selected.join(',');
  };

  useEffect(() => {
    setSelectedVariant(variants.find((v) => v?.attributes?.inStock === 'true' && v?.attributes?.size === chosenSize));
  }, [chosenSize]);

  useEffect(() => {
    setRelevantImages(variants?.find((v) => v?.attributes?.color === selectedColor).images);
  }, [selectedColor]);

  const hasOneSize = useMemo(() => {
    return (
      Array.from(
        new Set(
          variants
            .filter((variant) => variant?.attributes?.color === selectedColor && variant?.attributes.size === 'oneSize')
            .map((item) => item?.attributes?.size),
        ),
      ).length === 1
    );
  }, [selectedColor]);

  const handleAddToCart = async () => {
    if (loading || variant.attributes.inStock === 'false') return;
    if (selectedVariant !== null && (selectedVariant?.attributes?.size === chosenSize || hasOneSize)) {
      setLoading(true);
      await addItem(selectedVariant, quantity, getSelectedProducts());
      setLoading(false);
      setAdded(true);
    }
  };

  useEffect(() => {
    if (added) {
      setTimeout(() => {
        setAdded(false);
      }, 1000);
    }
  }, [added]);

  useEffect(() => {
    if (
      variant?.attributes?.size === savedSize &&
      variant?.attributes?.color === selectedColor &&
      variant?.attributes.inStock === 'true'
    ) {
      setChosenSize(savedSize);
      setSelectedSize(savedSize);
    }
  }, []);

  useEffect(() => {
    executeScroll();
  }, [open]);

  const onRemoveFromWishList = async (item: LineItem) => {
    await removeLineItem(item.lineItemId);
  };

  const onAddToWishList = async (sku: string) => {
    await addToWishlist(sku, 1);
  };

  const sortOrder = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'];

  const colorSelectorHandler = (e: string) => {
    setSelectedColor(e);
    if (
      variants?.filter(
        (variant) =>
          variant?.attributes?.color === e &&
          variant?.attributes?.size === savedSize &&
          variant?.attributes?.inStock === 'true',
      ).length > 0
    ) {
      setChosenSize(savedSize);
    } else {
      setChosenSize(null);
    }
  };

  const sizeSelectorHandler = (size: string) => {
    if (
      variants?.filter(
        (variant) =>
          variant?.attributes?.color === selectedColor &&
          variant?.attributes?.size === size &&
          variant?.attributes?.inStock === 'true',
      ).length > 0
    ) {
      setChosenSize(size);
      updateSavedSize(size);
    } else if (
      variants?.filter(
        (variant) => variant?.attributes?.color === selectedColor && variant?.attributes?.inStock === 'false',
      ).length > 0
    ) {
      setChosenSize('notAvailable');
    } else {
      setChosenSize(null);
    }
  };

  const executeScroll = () =>
    modalRef.current.scrollIntoView({
      behavior: 'smooth',
      block: isMobileSize ? 'start' : 'end',
      inline: isMobileSize ? 'start' : 'end',
    });

  return (
    <>
      {createPortal(
        <section>
          <div className="container mx-auto text-center">
            {open && (
              <div
                className={`border-stroke dark:border-dark-3 fixed left-2/4 top-2/4 z-50 max-h-[600px] w-10/12 -translate-x-1/2 -translate-y-1/2 overflow-scroll 
                rounded-[4px] border bg-white p-5 shadow-2xl sm:p-8 md:max-h-[840px] lg:w-[890px] lg:overflow-visible`}
                ref={modalRef}
                data-testid="quick-view"
              >
                <div className="mx-auto px-4 sm:container sm:px-0">
                  <div className="relative -mx-4 flex items-center justify-center">
                    <div ref={menuRef} className="relative">
                      <button
                        onClick={() => setOpen(false)}
                        className="text-body-color dark:text-dark-6 absolute right-0 top-0 flex items-center justify-center rounded-full hover:text-primary"
                      >
                        <svg
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="fill-current"
                        >
                          <path d="M11 10L18.625 2.375C18.9062 2.09375 18.9062 1.65625 18.625 1.375C18.3438 1.09375 17.9063 1.09375 17.625 1.375L10 9L2.375 1.375C2.09375 1.09375 1.65625 1.09375 1.375 1.375C1.09375 1.65625 1.09375 2.09375 1.375 2.375L9 10L1.375 17.625C1.09375 17.9063 1.09375 18.3438 1.375 18.625C1.5 18.75 1.6875 18.8438 1.875 18.8438C2.0625 18.8438 2.25 18.7812 2.375 18.625L10 11L17.625 18.625C17.75 18.75 17.9375 18.8438 18.125 18.8438C18.3125 18.8438 18.5 18.7812 18.625 18.625C18.9062 18.3438 18.9062 17.9063 18.625 17.625L11 10Z" />
                        </svg>
                      </button>
                      <div className="mt-10 items-start lg:mt-0 lg:flex">
                        <ImgBox
                          detailsLink={variant.href}
                          images={relevantImages}
                          detailsText={formatProductMessage({
                            id: 'viewDetails',
                            defaultMessage: 'View product details',
                          })}
                          recent={variant?.tags?.includes('new')}
                          sale={variant?.tags?.includes('sale')}
                        />

                        <div className="w-full text-left lg:ml-10 lg:max-w-[390px]">
                          <h3 className="text-dark mb-4 mr-4 text-xl font-bold dark:text-white xl:text-2xl xl:leading-[40px]">
                            {variant.title}
                          </h3>

                          {variant.description && (
                            <p className="mb-8 text-base font-medium text-[#808080]">{variant.description}</p>
                          )}

                          <div className="xs:flex mb-10 flex-wrap justify-between">
                            <div className="xs:text-right">
                              <span className="mb-1 flex items-center">
                                {variant.discountedCentAmount ? (
                                  <>
                                    <Price
                                      price={{ centAmount: variant.discountedCentAmount }}
                                      className="text-lg font-semibold text-gray-900"
                                    />
                                    <Price
                                      price={{ centAmount: variant?.priceCentAmount }}
                                      className="pl-6 text-sm font-medium text-[#808080] line-through decoration-[#808080] decoration-1"
                                    />
                                  </>
                                ) : (
                                  <Price
                                    price={{ centAmount: variant?.priceCentAmount }}
                                    className={`${
                                      variant.discountedCentAmount ? 'line-through' : ''
                                    } text-lg font-semibold text-gray-900`}
                                  />
                                )}
                              </span>
                            </div>
                            <p className="text-xs font-normal text-[#808080]">
                              {formatProductMessage({ id: 'vat.included', defaultMessage: 'incl. VAT' })}
                            </p>
                          </div>

                          {colors.filter((color) => color !== undefined).length > 0 && (
                            <div>
                              <h3 className="mb-4 text-sm font-medium text-black">
                                {formatProductMessage({ id: 'color.select', defaultMessage: 'Select color' })}
                              </h3>
                              <div className="mb-8 flex items-center">
                                <RadioGroup value={selectedColor} onChange={(e) => colorSelectorHandler(e)}>
                                  <div className="relative flex items-center space-x-3">
                                    {colors?.map((color) => (
                                      <RadioGroup.Option
                                        key={color}
                                        value={color}
                                        className={({ active, checked }) =>
                                          classNames(
                                            (active && checked) || selectedColor === color ? `${color}` : '',
                                            'relative flex cursor-pointer items-center justify-center p-0.5 focus:outline-none',
                                          )
                                        }
                                      >
                                        {selectedColor === color && (
                                          <div className="absolute left-0 flex w-full items-center justify-center">
                                            <svg
                                              width="14"
                                              height="8"
                                              viewBox="0 0 14 8"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M12.7522 0.564572C12.6184 0.439873 12.4082 0.439873 12.2744 0.564572L5.29803 6.87075C5.24069 6.92419 5.16424 6.92419 5.1069 6.87075L1.64741 3.73548C1.51361 3.61078 1.30337 3.61078 1.16958 3.73548C1.03578 3.86017 1.03578 4.05613 1.16958 4.18083L4.62907 7.3161C4.78198 7.45862 4.99222 7.52987 5.18335 7.52987C5.3936 7.52987 5.58473 7.45862 5.73764 7.3161L12.714 1.00992C12.8669 0.885225 12.8669 0.68927 12.7522 0.564572Z"
                                                fill={color?.toLowerCase() === 'white' ? 'black' : 'white'}
                                              />
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M13.0863 0.23222L13.0986 0.245562C13.3863 0.558375 13.3828 1.06122 13.0224 1.36506L6.05559 7.6626C5.81122 7.88897 5.50465 8 5.18336 8C4.88682 8 4.55941 7.89258 4.31092 7.6624L0.848699 4.52465C0.515257 4.21387 0.515288 3.70154 0.84873 3.39077C1.16229 3.09852 1.65073 3.09762 1.96536 3.38808L5.20276 6.32207L11.9567 0.216909C12.2713 -0.073284 12.7596 -0.0722998 13.073 0.219862L13.0863 0.23222ZM1.64741 3.73548C1.51361 3.61078 1.30337 3.61078 1.16958 3.73548C1.03578 3.86017 1.03578 4.05613 1.16958 4.18083L4.62907 7.3161C4.78198 7.45862 4.99222 7.52987 5.18335 7.52987C5.3936 7.52987 5.58473 7.45862 5.73764 7.3161L12.714 1.00992C12.8669 0.885225 12.8669 0.68927 12.7522 0.564572C12.6184 0.439873 12.4082 0.439873 12.2744 0.564572L5.29803 6.87075C5.24069 6.92419 5.16424 6.92419 5.1069 6.87075L1.64741 3.73548Z"
                                                fill={color?.toLowerCase() === 'white' ? 'black' : 'white'}
                                              />
                                            </svg>
                                          </div>
                                        )}
                                        <span
                                          aria-hidden="true"
                                          className={`
                                ${
                                  color?.toLowerCase() === 'multicolored'
                                    ? 'bg-gradient-to-r from-cyan-800 to-amber-300'
                                    : 'bg-' + color + '-500'
                                }
                                h-8 w-8 rounded
                                ${color?.toLowerCase() === 'white' ? 'border-[1px] border-[#E7E7E7]' : ''}`}
                                        />
                                      </RadioGroup.Option>
                                    ))}
                                  </div>
                                </RadioGroup>
                              </div>
                            </div>
                          )}

                          {sizes?.length && sizes.length > 0 && (
                            <div className="mb-12">
                              <div className="mb-4 flex w-full items-center justify-between">
                                <h3 className="text-sm font-medium text-black">
                                  {!hasOneSize
                                    ? formatProductMessage({ id: 'size.select', defaultMessage: 'Select size' })
                                    : formatProductMessage({
                                        id: 'size.hasOneSize',
                                        defaultMessage: 'This item has one size only',
                                      })}
                                </h3>
                                <h3 className="cursor-pointer text-sm font-medium text-black underline">
                                  {formatProductMessage({ id: 'size.table', defaultMessage: 'Size table' })}
                                </h3>
                              </div>

                              <RadioGroup value={chosenSize} onChange={(e) => setSelectedSize(e)} className="block">
                                <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
                                  {!hasOneSize &&
                                    Array.from(new Set(variants?.map((item) => item?.attributes?.size)))
                                      ?.filter((size) => size !== undefined)
                                      .sort(function (a, b) {
                                        return sortOrder.indexOf(a) - sortOrder.indexOf(b);
                                      })
                                      ?.map((size, idx) => (
                                        <div onClick={() => sizeSelectorHandler(size)} key={size}>
                                          <RadioGroup.Option
                                            value={{ key: size }}
                                            className={({ active, checked, disabled }) =>
                                              classNames(
                                                active || chosenSize === size || checked
                                                  ? 'border-0 bg-primary text-white'
                                                  : disabled
                                                  ? 'cursor-auto bg-[#EDEDED] text-[#808080]'
                                                  : 'text-gray-900 hover:bg-neutral-200',
                                                'flex cursor-pointer justify-center rounded border-[1px] border-[#E7E7E7] py-2 px-6 text-center font-light transition duration-150 ease-out',
                                              )
                                            }
                                            disabled={
                                              variants?.filter(
                                                (variant) =>
                                                  variant?.attributes?.color === selectedColor &&
                                                  variant?.attributes?.size === size &&
                                                  variant?.attributes?.inStock === 'true',
                                              ).length === 0
                                            }
                                          >
                                            {({ disabled }) => (
                                              <button
                                                type="button"
                                                className={`${disabled ? 'cursor-auto' : 'cursor-pointer'}`}
                                                data-testid={
                                                  disabled ? `out-of-stock-size-${idx}` : `available-size-${idx}`
                                                }
                                              >
                                                {size.toUpperCase()}
                                              </button>
                                            )}
                                          </RadioGroup.Option>
                                        </div>
                                      ))}
                                </div>
                              </RadioGroup>
                            </div>
                          )}

                          <div className="align-stretch flex w-full flex-col gap-4">
                            <button
                              type="button"
                              onClick={handleAddToCart}
                              className={classNames(
                                'flex w-full items-center justify-center rounded bg-primary py-3 px-8 text-center text-base font-bold text-white hover:bg-[#33B8A1] disabled:bg-[#EDEDED] disabled:text-[#808080]',

                                'flex w-full items-center justify-center rounded bg-primary py-3 px-8 text-center text-base font-bold text-white hover:bg-[#33B8A1] hover:fill-white hover:text-white',
                              )}
                              data-testid="addToCart"
                              disabled={
                                !variants.find((v) =>
                                  !hasOneSize
                                    ? v?.attributes?.size === chosenSize &&
                                      v?.attributes?.color === selectedColor &&
                                      v?.attributes?.inStock === 'true'
                                    : v?.attributes?.color === undefined
                                    ? v?.attributes?.inStock === 'true'
                                    : v?.attributes?.color === selectedColor && v?.attributes?.inStock === 'true',
                                )
                              }
                            >
                              {!loading && !added && (
                                <>
                                  {variants.find((v) =>
                                    !hasOneSize
                                      ? v?.attributes?.size === chosenSize &&
                                        v?.attributes?.color === selectedColor &&
                                        v?.attributes?.inStock === 'true'
                                      : v?.attributes?.color === undefined
                                      ? v?.attributes?.inStock === 'true'
                                      : v?.attributes?.color === selectedColor && v?.attributes?.inStock === 'true',
                                  )
                                    ? formatProductMessage({ id: 'bag.add', defaultMessage: 'Add to bag' })
                                    : !hasOneSize && chosenSize === null
                                    ? formatProductMessage({ id: 'chooseOptions', defaultMessage: 'Choose Options' })
                                    : formatProductMessage({ id: 'outOfStock', defaultMessage: 'Out of stock' })}
                                </>
                              )}

                              {loading && (
                                <svg
                                  className="h-6 w-6 animate-spin"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 25 25"
                                  fill="white"
                                >
                                  <path d="M8,8.5A3.5,3.5,0,1,1,4.5,5,3.5,3.5,0,0,1,8,8.5ZM4.5,14A3.5,3.5,0,1,0,8,17.5,3.5,3.5,0,0,0,4.5,14Zm16-2A3.5,3.5,0,1,0,17,8.5,3.5,3.5,0,0,0,20.5,12Zm0,2A3.5,3.5,0,1,0,24,17.5,3.5,3.5,0,0,0,20.5,14Zm-8,4A3.5,3.5,0,1,0,16,21.5,3.5,3.5,0,0,0,12.5,18Zm0-18A3.5,3.5,0,1,0,16,3.5,3.5,3.5,0,0,0,12.5,0Z" />
                                </svg>
                              )}
                              {!loading && added && (
                                <svg className="h-6 w-6" viewBox="0 0 80.588 61.158" fill="white">
                                  <path
                                    d="M29.658,61.157c-1.238,0-2.427-0.491-3.305-1.369L1.37,34.808c-1.826-1.825-1.826-4.785,0-6.611
                     c1.825-1.826,4.786-1.827,6.611,0l21.485,21.481L72.426,1.561c1.719-1.924,4.674-2.094,6.601-0.374
                     c1.926,1.72,2.094,4.675,0.374,6.601L33.145,59.595c-0.856,0.959-2.07,1.523-3.355,1.56C29.746,61.156,29.702,61.157,29.658,61.157z
                     "
                                  />
                                </svg>
                              )}
                            </button>

                            <button
                              type="button"
                              onClick={
                                !data?.lineItems?.find((lineItem) => lineItem?.productId === id)
                                  ? () => onAddToWishList(variant.sku)
                                  : () =>
                                      onRemoveFromWishList(data.lineItems.find((lineItem) => lineItem.productId === id))
                              }
                              className={classNames(
                                'flex w-full items-center justify-center rounded bg-primary py-3 px-8 text-center text-base font-bold text-[#242424] hover:bg-[#33B8A1] hover:text-[#FFFFFF] disabled:bg-[#EDEDED] disabled:text-[#808080]',
                                'flex w-full items-center justify-center rounded border-[1px] border-[#E7E7E7] bg-[#FFFFFF] py-3 px-8 text-center text-base font-bold text-[#242424] hover:border-[#33B8A1] hover:bg-[#33B8A1] hover:fill-white hover:text-[#FFFFFF]',
                              )}
                              data-testid="addToWishlist"
                            >
                              {!data?.lineItems?.find((lineItem) => lineItem?.productId === id)
                                ? formatProductMessage({ id: 'addToWishlist', defaultMessage: 'Add to wishlist' })
                                : formatProductMessage({
                                    id: 'removeFromWishlist',
                                    defaultMessage: 'Remove from wishlist',
                                  })}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>,
        document.body,
      )}
    </>
  );
};
